<template>
<div class="container">
   <el-upload
  class="upload-demo"
  ref="upload"
  action="https://jsonplaceholder.typicode.com/posts/"
  :on-change="handlePreview"
  :on-remove="handleRemove"
  :file-list="fileList"
  :limit="1"
  :auto-upload="false">
  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
  <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
</el-upload>


<el-button @click="auto" size="small" type="primary">auto</el-button>
<el-button @click="getCategory" size="small" type="primary">getCategory</el-button>
<el-button @click="add" size="small" type="primary">add</el-button>
<el-button @click="q" size="small" type="primary">q</el-button>
<el-button @click="b" size="small" type="primary">b</el-button>
</div>
</template>

<script>
export default {
    data() {
      return {
        fileList: [],
        file:null
      };
    },
    methods: {
       b(){
          let p = {
           deviceId:'BC00334PAJ326F9',
            categoryCode: 'ASI',
            devCode: 'Dolynk_aHVpaGUxMjMzMjE='
          }
       this.$post('/device/device/busniss',p)
    },
      q(){
          let p = {
            pageNum:1,
            pageSize:10
          }
       this.$post('/device/device/queryDevice',p)
    },
        add(){
          let p = {
            deviceId:'BC00334PAJ326F9',
            categoryCode: 'ASI',
            devCode: '123'
          }
       this.$post('/device/device/addDevice',p)
    },
      auto(){
       this.$get('/device/device/reToken',{})
    },
    getCategory(){
       this.$post('/device/device/getCategory',{deviceModel: 'DH-ASI31D-MW'})
    },
      submitUpload() {
        var formData = new FormData();
         formData.append("file", this.file);
         formData.append("user", "147616a");
          this.$axios({
            method: 'post',
            url: '/device/d/updateFace',
            data:formData
            })
            .then((res) => {
              
               
            })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        this.file = file.raw
      }
    }
  }
</script>

